module.exports = __webpack_public_path__ + "img/team.c20da6e2.jpg";